<template>
  <div class="content-container">
    <a-form-model class="search-form" layout="inline" :model="searchForm">
      <a-form-model-item
        has-feedback
        :label="$t('form.common.field.account.label')"
      >
        <a-input
          v-model="searchForm.name"
          :placeholder="$t('message.checkInputHint')"
        />
      </a-form-model-item>
      <a-form-model-item
        has-feedback
        :label="$t('form.common.field.state.label')"
      >
        <a-select
          mode="multiple"
          :placeholder="$t('form.common.field.state.label')"
          style="width: 150px"
          v-model="searchForm.expire_statuses"
        >
          <a-select-option value="0">{{
            $t("enum.expireStatus.0")
          }}</a-select-option>
          <a-select-option value="1">{{
            $t("enum.expireStatus.1")
          }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="search">{{
          $t(`actionTitles.submit`)
        }}</a-button>
        <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{
          $t(`actionTitles.clear`)
        }}</a-button>
        <!-- <a :style="{ marginLeft: '8px', fontSize: '12px' }" @click="toggle">
          {{expand ? $t('message.collapseClose'):$t('message.collapseOpen')}}
          <a-icon :type="expand ? 'up' : 'down'" />
        </a>-->
      </a-form-model-item>
    </a-form-model>
    <div class="table-wrapper">
      <div class="opration-wrapper">
        <a-button @click="handleAdd" type="primary" icon="plus">{{
          $t(`actionTitles.create`)
        }}</a-button>
      </div>
      <clear-selected
        alert-type="info"
        :show="selectedRowKeys.length > 0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      />

      <a-table
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :data-source="pageResult.data"
        :loading="loading"
        rowKey="id"
        :pagination="pagination"
        @change="handleTableChange"
      >
        <a-table-column
          key="phone"
          :title="$t('table.user.thead.account')"
          data-index="phone"
        />
        <a-table-column
          key="name"
          :title="$t('table.common.thead.dealer')"
          data-index="name"
          align="center"
        />
        <a-table-column
          key="child_num"
          :title="$t('table.user.thead.acountCount')"
          data-index="child_num"
          align="center"
        />
        <a-table-column
          key="child_limit"
          :title="$t('table.user.thead.childLimit')"
          data-index="child_limit"
          align="center"
        />
        <a-table-column
          key="total_works"
          :sorter="true"
          :title="$t('table.user.thead.worksCount')"
          data-index="total_works"
          align="center"
        />
        <a-table-column
          key="expire_status"
          :filters="filters"
          :title="$t('table.common.thead.state')"
          data-index="expire_status"
          align="center"
        >
          <template slot-scope="text, record">{{
            $t(`enum.expireStatus.${record.expire_status}`)
          }}</template>
        </a-table-column>
        <a-table-column
          key="expire_time"
          :sorter="true"
          :title="$t('table.common.thead.expireTime')"
          data-index="expire_time"
          align="center"
        />
        <a-table-column
          key="operate"
          :title="$t('table.common.thead.operate')"
          align="center"
        >
          <template slot-scope="text, record">
            <span>
              <a @click="resetPassword(record.id)">{{
                $t("login.resetPassword")
              }}</a>
              <a-divider type="vertical" />
              <a @click="detail(record)">{{ $t("actionTitles.detail") }}</a>
              <a-divider type="vertical" />
              <a @click="config(record.id)">{{ $t("actionTitles.config") }}</a>
              <a-divider type="vertical" />
              <a @click="viewSubAccount(record.id)">{{ $t("actionTitles.ViewSubAccount") }}</a>
              <a-divider type="vertical" />
              <a-popconfirm
                placement="top"
                :ok-text="$t('actionTitles.yes')"
                :cancel-text="$t('actionTitles.no')"
                @confirm="handleDelete(record.id)"
              >
                <template slot="title">{{ $t("message.delUser") }}</template>
                <a style="color: red">{{ $t("actionTitles.delete") }}</a>
              </a-popconfirm>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <!--編輯彈窗 -->
    <a-modal
      v-model="exitVisible"
      :title="$t('moduleTitles.addUser')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="handleSave"
      width="740px"
    >
      <a-form-model
        ref="ruleForm"
        layout="horizontal"
        :form="form"
        :rules="rules"
        :model="form"
        v-bind="layout"
      >
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.mobile.label')"
          prop="phone"
        >
          <a-input
            v-model="form.phone"
            :placeholder="
              $t('form.common.field.mobile.message') + $t('message.phoneHint')
            "
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.password.label')"
          prop="password"
        >
          <a-input-password
            v-model="form.password"
            :placeholder="$t('form.common.field.password.message')"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.nickname.label')"
          prop="name"
        >
          <a-input
            v-model="form.name"
            :placeholder="$t('form.user.field.nickname.message')"
          />
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.linkman.label')"
          prop="linkman"
        >
          <a-input
            v-model="form.linkman"
            :placeholder="$t('form.user.field.linkman.message')"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.user.field.childLimit.label')"
          prop="child_limit"
        >
          <a-input-number v-model="form.child_limit" />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.gender.label')"
        >
          <a-radio-group v-model="form.gender">
            <a-radio :value="1">{{ $t("enum.gender.male") }}</a-radio>
            <a-radio :value="0">{{ $t("enum.gender.female") }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.area.label')"
        >
          <h-region-select
            @regionData="selectedData"
            :defaultValue="defaultValue"
          ></h-region-select>
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.address.label')"
          prop="address"
        >
          <a-textarea
            v-model="form.address"
            :placeholder="$t('form.common.field.address.message')"
            allow-clear
          />
        </a-form-model-item>

        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.wechat.label')"
        >
          <a-input
            v-model="form.wechat"
            :placeholder="$t('form.common.field.wechat.message')"
          />
        </a-form-model-item>
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.email.label')"
          prop="email"
        >
          <a-input
            v-model="form.email"
            :placeholder="$t('form.common.field.email.message')"
          />
        </a-form-model-item>
        <a-form-model-item
            has-feedback
            :label="$t('form.common.field.store_type.label')"
            prop="brand"
        >
          <a-select default-value="0" style="width: 120px" @change="handleChangeBrand">
            <a-select-option value="0">
              請選擇品牌
            </a-select-option>
            <a-select-option value="1">{{ $t("enum.store_type[1]") }}</a-select-option>
            <a-select-option value="2">{{ $t("enum.store_type[2]") }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
            has-feedback
            :label="$t('form.common.field.store_id.label')"
            prop="store_id"
        >
          <a-input
              v-model="form.store_id"
              :placeholder="$t('form.common.field.store_id.placeholder')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--重置密碼-->
    <a-modal
      v-model="updatePasswordModel"
      :title="$t('login.resetPassword')"
      :ok-text="$t('actionTitles.save')"
      :cancel-text="$t('actionTitles.cancel')"
      @ok="updatePassword"
    >
      <a-form-model
        ref="updatePasswordForm"
        layout="vertical"
        :form="updatePasswordForm"
        :rules="passwordRules"
        :model="updatePasswordForm"
      >
        <a-form-model-item
          has-feedback
          :label="$t('form.common.field.password.label')"
          prop="password"
        >
          <a-input-password
            v-model="updatePasswordForm.password"
            :placeholder="$t('form.common.field.password.message')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import {
  dealerPageQuery,
  createDealer,
  softDelete,
  resetPassword,
} from "@/api/user";
import HRegionSelect from "@/components/HRegionSelect";
import { validatephone } from "@/utils/validate";

export default {
  components: { ClearSelected, HRegionSelect },

  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      loading: false,
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 },
      },
      searchForm: {},
      expand: false,
      form: {
        phone: "",
        name: "",
        linkman: "",
        address: "",
        gender: 1,
        store_type:0,
      },
      pageResult: [],
      selectedRowKeys: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      filters: [
        { text: this.$i18n.t("enum.expireStatus.0"), value: "0" },
        { text: this.$i18n.t("enum.expireStatus.1"), value: "1" },
      ],
      exitVisible: false,
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("form.common.field.phone.message"),
            trigger: "blur",
          },
          { validator: phoneCheck, trigger: "blur" },
        ],
        name: [
          {
            required: true,
            message: this.$t("form.user.field.nickname.message"),
            trigger: "blur",
          },
        ],
        linkman: [
          {
            required: true,
            message: this.$t("form.user.field.linkman.message"),
            trigger: "blur",
          },
        ],
        child_limit: [
          {
            required: true,
            message: this.$t("form.user.field.childLimit.message"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("form.common.field.address.message"),
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: this.$t("form.userDetail.form.field.email.checkMessage"),
            trigger: "blur",
          },
        ],
      },
      defaultValue: [],
      updatePasswordModel: false,
      updatePasswordForm: {
        id: 0,
        password: "",
      },
      passwordRules: {
        password: [
          {
            required: true,
            message: this.$t("form.common.field.password.message"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
  },
  updated() {
    console.log("updated");
  },
  mounted() {
    this.loadData();
  },
  methods: {
    resetPassword(userId) {
      this.updatePasswordModel = true;
      this.updatePasswordForm = { ...{ id: userId, password: "" } };
      setTimeout(() => {
        this.$refs["updatePasswordForm"].resetFields();
      }, 0);
    },
    updatePassword() {
      this.$refs.updatePasswordForm.validate((valid) => {
        if (valid) {
          resetPassword(this.updatePasswordForm).then((res) => {
            this.$message.success(this.$t("message.saveSuccess"));
            this.updatePasswordModel = false;
          });
        }
      });
    },
    //數據加載
    loadData() {
      this.loading = true;
      this.searchParam = {
        ...this.searchForm,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      dealerPageQuery(this.searchParam)
        .then((res) => {
          this.loading = false;
          this.pageResult = res.data;
          this.pagination.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //table 翻頁
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(filters).length > 0) {
        this.searchForm.expire_statuses = filters.expire_status;
      }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
        console.log(this.searchForm.order);
      }
      this.loadData();
    },
    handleAdd() {
      this.exitVisible = true;
      setTimeout(() => {
        this.exitModelRest();
      }, 0);
    },
    handleSave() {
      console.log(this.form);
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.username = this.form.phone;
          createDealer(this.form).then((res) => {
            this.loadData();
            this.$message.success(this.$t("message.saveSuccess"));
            this.exitVisible = false;
          });
        }
      });
    },
    handleDelete(id) {
      let ids = [id];
      this.delete(ids);
    },
    delete(ids) {
      softDelete({ id: ids }).then((res) => {
        this.loadData();
        this.$message.success(this.$t("message.deleteSuccess"));
      });
    },
    handleChange(val) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$i18n.t("message.selectHint"));
        return;
      }
      if (val.key == "delete") {
        this.delete(this.selectedRowKeys);
      }
    },
    detail(record) {
      this.$router.push({
        path: "/admin/agent/detail",
        query: { userId: record.id },
      });
    },
    config(userId) {
      this.$router.push({
        path: "/admin/agent/config",
        query: { userId },
      });
    },
    viewSubAccount(pid) {
      this.$router.push({
        name: "adminUserList",
        params: { pid },
      });
    },
    handleReset() {
      this.searchForm = {};
      this.pagination.current=1;
      this.loadData();
    },
    exitModelRest() {
      this.form = { gender: 1 };
      this.$refs["ruleForm"].resetFields();
    },
    selectedData(val) {
      this.form.region = val;
    },
    toggle() {
      this.expand = !this.expand;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    },
    handleChangeBrand(value){
      this.form.store_type = value
      console.log(value)
    }
  },
};
</script>

<style lang="less" scoped>
</style>
